module.exports = __webpack_public_path__ + "img/third1.f3650f04.svg";